import { FEATURES_STATUSES } from './features';
export const idToPluralType = {
  '0-1': 'contacts',
  '0-2': 'companies',
  '0-3': 'deals',
  '0-5': 'tickets',
  '0-47': 'meetings'
};
export const pluralTypeToId = {
  contacts: '0-1',
  companies: '0-2',
  deals: '0-3',
  tickets: '0-5',
  meetings: '0-47'
};
export const pluralTypeToSingle = {
  contacts: 'contact',
  companies: 'company',
  deals: 'deal',
  tickets: 'ticket',
  meetings: 'meeting'
};
export const objectTypes = {
  contacts: 'contacts',
  companies: 'companies',
  deals: 'deals',
  tickets: 'tickets',
  meetings: 'meetings'
};
export const singularTypeToPlural = {
  contact: 'contacts',
  company: 'companies',
  deal: 'deals',
  ticket: 'tickets',
  meeting: 'meetings'
};
export const toObjectTypes = {
  contact: 'contact',
  company: 'company',
  deal: 'deal',
  ticket: 'ticket',
  meeting: 'meeting'
};
export const featureTypes = {
  contacts: FEATURES_STATUSES.ASSOCIATIONS_CONTACTS_WITH_CALL,
  companies: FEATURES_STATUSES.ASSOCIATIONS_COMPANIES_WITH_CALL,
  deals: FEATURES_STATUSES.ASSOCIATIONS_DEALS_WITH_CALL,
  tickets: FEATURES_STATUSES.ASSOCIATIONS_TICKETS_WITH_CALL,
  meetings: FEATURES_STATUSES.ASSOCIATIONS_MEETINGS_WITH_CALL
};
export const associationTypesToCall = {
  contacts: 'contact_to_call',
  companies: 'company_to_call',
  deals: 'deal_to_call',
  tickets: 'ticket_to_call',
  meetings: 'meeting_event_to_call'
};
export const pluralTypeToSingularUpperCase = {
  contacts: 'CONTACT',
  companies: 'COMPANY',
  deals: 'DEAL',
  tickets: 'TICKET',
  meetings: 'MEETING'
};
export const typeToId = {
  callObject: '0-48',
  lineItem: '0-8',
  product: '0-7'
};
export const ASSOCIATION_TYPE_IDS = {
  LINE_ITEMS_TO_DEAL: 20
};
export const CRM_OBJECT_TYPES = Object.assign({}, objectTypes, {
  line_items: 'line_items',
  calls: 'calls'
});